/* Canonical data-testid catalogue. */
export const NAV = {
  logo: "nav-logo-link",
  platform: "nav-link-platform",
  solutions: "nav-link-solutions",
  frameworks: "nav-link-frameworks",
  compliance: "nav-link-compliance",
  team: "nav-link-team",
  enterprise: "nav-link-enterprise",
  contact: "nav-link-contact",
  login: "nav-client-login",
  demo: "nav-request-demo",
};

export const HOME = {
  heroDemoBtn: "home-hero-demo-btn",
  heroLearnBtn: "home-hero-learn-btn",
  moduleTab: (i) => `home-module-tab-${i}`,
  industryTab: (i) => `home-industry-tab-${i}`,
  stepTab: (i) => `home-step-tab-${i}`,
  stepPrev: "home-step-prev",
  stepNext: "home-step-next",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  company: "contact-company",
  role: "contact-role",
  sector: "contact-sector",
  environment: "contact-environment",
  honeypot: "contact-honeypot",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const LOGIN = {
  form: "login-form",
  email: "login-email",
  password: "login-password",
  submit: "login-submit",
  error: "login-error",
};

export const ADMIN = {
  root: "admin-root",
  logout: "admin-logout",
  tabDashboard: "admin-tab-dashboard",
  tabLeads: "admin-tab-leads",
  tabExport: "admin-tab-export",
  search: "admin-search",
  statusFilter: "admin-status-filter",
  sectorFilter: "admin-sector-filter",
  leadRow: (id) => `admin-lead-row-${id}`,
  leadOpen: (id) => `admin-lead-open-${id}`,
  detailStatus: "admin-detail-status",
  detailPriority: "admin-detail-priority",
  detailAssignee: "admin-detail-assignee",
  detailDelete: "admin-detail-delete",
  noteInput: "admin-note-input",
  noteSubmit: "admin-note-submit",
  exportCsv: "admin-export-csv",
};
